export enum UserGroup {
  ADMIN_TECH = 'admin_tech',
  TEST_NONE = 'none',
  ADMIN_COORDINATOR = 'admin_coordinator'
}
